import React, { useState } from 'react';
import './mobile-order-summary.scss';
import CartItemSummary from '../cart-item-summary/cart-item-summary';
import RoundButtonIcon from '../../../../components/round-button-icon/RoundButtonIcon';
import { Accordion } from '@ampol/design-system';
import isEmpty from 'utilities/isEmpty';

/**
 * An order summary component containing cart item summaries
 * @param cashOrderCartItems The key/value pair object containing cart items
 * @param cashCartSubTotal The subtotal for the cart items
 * @param addEditAmpolCash onClick event for Add/Edit AmpolCash option
 * @returns JSX Element
 */

const MobileOrderSummary = ({ cashOrderCartItems, cashCartSubTotal, addEditAmpolCash, onRemove }) => {
  const [showList, setShowList] = useState(false);

  return <>
    <div className='mobile-orders'>
      <Accordion title='Order Summary' open={showList} onClick={() => setShowList(!showList)} > 
        {showList && <div className='mobile-orders__cart'>
          <div className='mobile-orders__cart-items'>
            <hr />
            {isEmpty(cashOrderCartItems) && <div className="mobile-orders__empty-cart-message">Add items to your cart to start an order.</div>}
            <ul aria-label='cart items'>
              {Object.entries(cashOrderCartItems).map(([uuid, item]) =>
                <li key={uuid}>
                  <CartItemSummary
                    showBase={true}
                    showImage={false}
                    showTotal={false}
                    showQuantity={true}
                    showDelivery={true}
                    cartItem={item}
                  />
                  <div className='mobile-orders__total-and-button'>
                    ${item.total}
                    {onRemove && <RoundButtonIcon
                      plusIcon={false}
                      buttonColor={'red'}
                      iconColor={'white'}
                      inactive={false}
                      alt={'remove cart item'}
                      formId={undefined}
                      type={'button'}
                      onClick={() => onRemove?.(item)}
                    />}
                  </div>
                </li>
              )}
            </ul>
          </div>
          <div className='mobile-orders__footer'>
            {addEditAmpolCash && <button onClick={addEditAmpolCash} className='mobile-orders__add'>Add/Edit AmpolCash</button>}
            <hr />
            <ul className='mobile-orders__total'>
              <li>Sub Total</li>
              <li>${cashCartSubTotal}</li>
            </ul>
          </div>
        </div>}
      </Accordion>
    </div>
  </>;

};

export default MobileOrderSummary;
